'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _chunk2 = require('lodash/chunk');

var _chunk3 = _interopRequireDefault(_chunk2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ConfirmDelete = require('../common/ConfirmDelete');

var _ConfirmDelete2 = _interopRequireDefault(_ConfirmDelete);

var _mightyFields = require('../../lib/mighty-fields');

var _util = require('../../utils/util');

var _GenericFundingFormModal = require('./main-fundings/GenericFundingFormModal');

var _GenericFundingFormModal2 = _interopRequireDefault(_GenericFundingFormModal);

var _DeleteLienButton = require('./DeleteLienButton');

var _DeleteLienButton2 = _interopRequireDefault(_DeleteLienButton);

var _LienDocuments = require('./main-fundings/LienDocuments');

var _LienDocuments2 = _interopRequireDefault(_LienDocuments);

var _ReturnDetailsWell = require('./ReturnDetailsWell');

var _ReturnDetailsWell2 = _interopRequireDefault(_ReturnDetailsWell);

var _CapitalFundingsList = require('./main-details/capital-fundings/CapitalFundingsList');

var _LienInfoEditableCard = require('./LienInfoEditableCard');

var _LienInfoEditableCard2 = _interopRequireDefault(_LienInfoEditableCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var GenericFundingDetailsModal = (_dec = (0, _mobxReact.inject)('CaseStore', 'LienStore', 'OptionsStore', 'FunderStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(GenericFundingDetailsModal, _Component);

  function GenericFundingDetailsModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GenericFundingDetailsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GenericFundingDetailsModal.__proto__ || Object.getPrototypeOf(GenericFundingDetailsModal)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showDeleteLienConfirmation', _descriptor, _this), _initDefineProp(_this, 'loading', _descriptor2, _this), _initDefineProp(_this, 'lien', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GenericFundingDetailsModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchLienData();
    }
  }, {
    key: 'fetchLienData',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, lienId, LienStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, lienId = _props.lienId, LienStore = _props.LienStore;
                _context.next = 3;
                return LienStore.retrieve(lienId, 'generic', { includeDocuments: true });

              case 3:
                this.lien = _context.sent;

                this.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchLienData() {
        return _ref2.apply(this, arguments);
      }

      return fetchLienData;
    }()
  }, {
    key: 'toggleShowDeleteLienConfirmation',
    value: function toggleShowDeleteLienConfirmation() {
      this.showDeleteLienConfirmation = !this.showDeleteLienConfirmation;
    }
  }, {
    key: 'updateLienDetails',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var LienStore;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                LienStore = this.props.LienStore;
                _context2.next = 3;
                return LienStore.update(this.lien, data);

              case 3:
                this.lien = _context2.sent;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateLienDetails(_x) {
        return _ref3.apply(this, arguments);
      }

      return updateLienDetails;
    }()
  }, {
    key: 'renderLienDocuments',
    value: function renderLienDocuments() {
      if (!this.lien || !this.lien.documents) {
        return null;
      }

      return _react2.default.createElement(_LienDocuments2.default, { documents: (0, _mobx.toJS)((0, _get3.default)(this.lien, 'documents')), lien: this.lien });
    }
  }, {
    key: 'handleDeleteLienClick',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _props2, LienStore, onClose;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props2 = this.props, LienStore = _props2.LienStore, onClose = _props2.onClose;

                LienStore.delete({ caseId: this.lien.case, lienId: this.lien.id });
                onClose();

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleDeleteLienClick() {
        return _ref4.apply(this, arguments);
      }

      return handleDeleteLienClick;
    }()
  }, {
    key: 'renderCapitalProviders',
    value: function renderCapitalProviders() {
      var FunderStore = this.props.FunderStore,
          _lien = this.lien,
          capital_fundings = _lien.capital_fundings,
          id = _lien.id;


      if (!FunderStore.canSeeCapitalProviders || !id) {
        return;
      }

      return _react2.default.createElement(_CapitalFundingsList.GuardedCapitalFundingsList, { lienId: id, capitalFundings: (0, _mobx.toJS)(capital_fundings) });
    }
  }, {
    key: 'modalComponent',
    value: function modalComponent(props) {
      return _react2.default.createElement(_GenericFundingFormModal2.default, _extends({ lien: this.lien }, this.props));
    }
  }, {
    key: 'renderLienDetails',
    value: function renderLienDetails() {
      var isFinanceCustomer = this.props.FunderStore.isFinanceCustomer,
          lienData = _extends({}, this.lien, {
        estimated_case_value: this.props._case.value,
        subtype: (0, _get3.default)(this.lien, 'subtype.name')
      });


      return _react2.default.createElement(_mightyFields.EditableCard, {
        fieldSets: _GenericFundingFormModal2.default.fieldSets(isFinanceCustomer),
        model: lienData,
        onSave: this.updateLienDetails,
        title: 'Edit Lien Details',
        modalComponent: this.modalComponent
      });
    }
  }, {
    key: 'updateCustomFields',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(custom_field_data) {
        var LienStore, customFieldData, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                LienStore = this.props.LienStore, customFieldData = (0, _get3.default)(this.lien, 'custom_field_data', {}), data = { custom_field_data: _extends({}, customFieldData, custom_field_data) };
                _context4.next = 3;
                return LienStore.update(this.lien, data);

              case 3:
                this.lien = _context4.sent;

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateCustomFields(_x2) {
        return _ref5.apply(this, arguments);
      }

      return updateCustomFields;
    }()
  }, {
    key: 'renderCustomLienFields',
    value: function renderCustomLienFields() {
      var _this2 = this;

      var funderFields = (0, _get3.default)(this.props.FunderStore, 'funder.custom_lien_fields', []),
          funderFieldTypes = (0, _get3.default)(this.props.FunderStore, 'funder.custom_lien_field_types'),
          dataFields = Object.keys((0, _get3.default)(this.lien, 'custom_field_data', [])),
          customFields = (0, _util.joinCustomFields)(funderFields, dataFields),
          fieldSets = (0, _chunk3.default)(customFields.map(function (field) {
        return (0, _util.getCustomFieldset)(funderFieldTypes, field);
      }), 50) // eslint-disable-line no-magic-numbers
      ;

      if (!customFields.length) {
        return null;
      }

      return fieldSets.map(function (fieldSet, idx) {
        return _react2.default.createElement(_mightyFields.EditableCard, {
          key: 'custom-field-sets-' + idx,
          fieldSets: [fieldSet],
          model: _this2.lien.custom_field_data,
          onSave: _this2.updateCustomFields,
          title: 'Additional Lien Information'
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var onClose = this.props.onClose,
          confirmDeleteMessage = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Are you sure you want to delete this lien and application?'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Warning: this cannot be undone.'
          )
        )
      );


      return _react2.default.createElement(
        _Modal2.default,
        { show: true, className: 'right side-modal modal-generic-lien-details', onHide: onClose },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: true },
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            'Lien Details'
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          this.loading ? _react2.default.createElement(
            'div',
            { className: 'loading' },
            'Loading...'
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_LienInfoEditableCard2.default, { lien: this.lien, priorFunding: this.priorFunding }),
            this.renderLienDocuments(),
            this.renderLienDetails(),
            (0, _get3.default)(this.lien, 'lien_returns', []).map(function (lien_return) {
              return _react2.default.createElement(_ReturnDetailsWell2.default, { key: lien_return.id, lien: _this3.lien, lien_return: lien_return });
            }),
            this.renderCapitalProviders(),
            this.renderCustomLienFields(),
            _react2.default.createElement(
              _ButtonToolbar2.default,
              { className: 'lien-delete' },
              _react2.default.createElement(_DeleteLienButton2.default, { onClick: this.toggleShowDeleteLienConfirmation })
            ),
            _react2.default.createElement(_ConfirmDelete2.default, {
              fixed: true,
              message: confirmDeleteMessage,
              showConfirmDelete: this.showDeleteLienConfirmation,
              onClickDelete: this.handleDeleteLienClick,
              onClickCancel: this.toggleShowDeleteLienConfirmation
            })
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return GenericFundingDetailsModal;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  lienId: _propTypes2.default.string.isRequired,
  LienStore: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showDeleteLienConfirmation', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'loading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'lien', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return (0, _mobx.observable)({});
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'fetchLienData', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchLienData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateLienDetails', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'updateLienDetails'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDeleteLienClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleDeleteLienClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateCustomFields', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'updateCustomFields'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = GenericFundingDetailsModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GenericFundingDetailsModal, 'GenericFundingDetailsModal', '/app/src/components/page-case/GenericFundingDetailsModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/GenericFundingDetailsModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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